import { ProductPaymentItemModel } from "./ProductPaymentItem.model";
import { EProductType } from "../EProductType.enum";
import { ProductsDetail1 } from "./ProductsDetail.model";

export class PaymentsItemModel {

  productId: string;
  productName: string;
  productType: EProductType
  productQty: number;
  productAmount: number;
  isChecked: boolean;
  notes: string;
  accessType:number;
  saleProducts: ProductsDetail1[];
  otherCharges:number=0;

}
